import { HighlightLeftCard } from "@totalenergiescode/mobility-business-rev-design-system";
import { useFormDataContext } from "@totalenergiescode/mobility-business-rev-form-data/components";
import { useState } from "react";

import {
  StyledAnomaliesViewer,
  StyledAnomaliesViewerContent,
  StyledCollapse,
} from "@/components/FormData/debug/anomalies/styles.tsx";

const AnomaliesViewer = () => {
  const { formHasBeenLoaded, anomalies, translator } = useFormDataContext();

  const [isGlobalAnomaliesCollapsed, setIsGlobalAnomaliesCollapsed] =
    useState(false);
  const [isFieldAnomaliesCollapsed, setIsFieldAnomaliesCollapsed] =
    useState(false);

  return (
    <StyledAnomaliesViewer>
      {formHasBeenLoaded && anomalies.notEmpty() ? (
        <>
          <StyledCollapse
            title={translator.translate("anomalies.globals", {
              count: anomalies.countGlobalAnomalies(),
            })}
            in={isGlobalAnomaliesCollapsed}
            handleCollapse={() =>
              setIsGlobalAnomaliesCollapsed(!isGlobalAnomaliesCollapsed)
            }
          >
            <StyledAnomaliesViewerContent>
              {anomalies.hasGlobalAnomalies() &&
                anomalies.globals.map((anomaly, index) => (
                  <HighlightLeftCard
                    key={index}
                    highlightColor='red'
                    borderColor=''
                  >
                    <div>{anomaly.message}</div>
                  </HighlightLeftCard>
                ))}
            </StyledAnomaliesViewerContent>
          </StyledCollapse>

          <StyledCollapse
            title={translator.translate("anomalies.fields", {
              count: anomalies.countFieldAnomalies(),
            })}
            in={isFieldAnomaliesCollapsed}
            handleCollapse={() =>
              setIsFieldAnomaliesCollapsed(!isFieldAnomaliesCollapsed)
            }
          >
            <StyledAnomaliesViewerContent>
              {anomalies.hasFieldAnomalies() &&
                anomalies.fieldsIterator().map(([fieldId, anomalies]) => (
                  <HighlightLeftCard
                    key={fieldId}
                    highlightColor='red'
                    borderColor='#E5E7EB'
                    title='toto'
                  >
                    <div style={{ padding: "16px" }}>
                      <h3
                        style={{
                          fontSize: "18px",
                          fontWeight: "600",
                          margin: "0 0 8px 0",
                        }}
                      >
                        {fieldId}
                      </h3>
                      {anomalies.map((anomaly, index) => (
                        <p
                          style={{
                            color: "#6B7280",
                            margin: 0,
                          }}
                          key={index}
                        >
                          {anomaly.message}
                        </p>
                      ))}
                    </div>
                  </HighlightLeftCard>
                ))}
            </StyledAnomaliesViewerContent>
          </StyledCollapse>
        </>
      ) : (
        <div>{translator.translate("anomalies.empty")}</div>
      )}
    </StyledAnomaliesViewer>
  );
};

export default AnomaliesViewer;
